<template>
	<popup-system v-bind="{ system, systemId }" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import PopupSystem from '@/common/popup/components/PopupSystem.vue';

import { DialogSystem } from '../DialogSystem';

export default defineComponent({
	components: {
		PopupSystem,
	},

	setup() {
		return {
			system: DialogSystem.instance,
			systemId: DialogSystem.systemId,
		};
	},
});
</script>

<style lang="scss"></style>
